"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentManagementQueryService = void 0;
const mappers_1 = require("../mappers");
const webhook_mapper_1 = require("../mappers/webhook-mapper");
const base_content_management_service_class_1 = require("./base-content-management-service.class");
const environment_mapper_1 = require("../mappers/environment-mapper");
class ContentManagementQueryService extends base_content_management_service_class_1.BaseContentManagementQueryService {
    constructor(config, httpService, sdkInfo) {
        super(config, httpService, sdkInfo);
        this.config = config;
        this.httpService = httpService;
        this.sdkInfo = sdkInfo;
    }
    genericPostResponse(url, data, config) {
        const _super = Object.create(null, {
            postResponseAsync: { get: () => super.postResponseAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.genericMapper.mapGenericResponse(yield _super.postResponseAsync.call(this, url, data, {}, config));
        });
    }
    genericPatchResponse(url, data, config) {
        const _super = Object.create(null, {
            patchResponseAsync: { get: () => super.patchResponseAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.genericMapper.mapGenericResponse(yield _super.patchResponseAsync.call(this, url, data, {}, config));
        });
    }
    genericDeleteResponse(url, config) {
        const _super = Object.create(null, {
            deleteResponseAsync: { get: () => super.deleteResponseAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.genericMapper.mapGenericResponse(yield _super.deleteResponseAsync.call(this, url, {}, config));
        });
    }
    genericGetResponse(url, config) {
        const _super = Object.create(null, {
            getResponseAsync: { get: () => super.getResponseAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.genericMapper.mapGenericResponse(yield _super.getResponseAsync.call(this, url, {}, config));
        });
    }
    genericPutResponse(url, data, config) {
        const _super = Object.create(null, {
            putResponseAsync: { get: () => super.putResponseAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.genericMapper.mapGenericResponse(yield _super.putResponseAsync.call(this, url, data, {}, config));
        });
    }
    getListAllResponse(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const responses = yield this.getListAllResponseInternalAsync({
                resolvedResponses: [],
                getResponse: data.getResponse,
                xContinuationToken: undefined,
                listQueryConfig: data.listQueryConfig
            });
            return data.allResponseFactory(responses.reduce((prev, current) => {
                prev.push(...current.data.items);
                return prev;
            }, []), responses);
        });
    }
    publishLanguageVariant(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    createNewVersionOfLanguageVariant(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, undefined, {}, config));
        });
    }
    unpublishLanguageVariant(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    cancelScheduledPublishingOfLanguageVariant(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, undefined, {}, config));
        });
    }
    cancelScheduledUnpublishingOfLanguageVariant(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, undefined, {}, config));
        });
    }
    changeWorkflowStepOfLanguageVariant(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, undefined, {}, config));
        });
    }
    changeWorkflowOfLanguageVariant(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapEmptyResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    listWorkflowSteps(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapListWorkflowStepsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listWorkflows(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapListWorkflowsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    addWorkflow(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapAddWorkflowResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    updateWorkflow(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.workflowMapper.mapUpdateWorkflowResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    deleteWorkflow(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    viewContentTypeSnippet(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeSnippetMapper.mapViewContentTypeSnippetResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    deleteContentTypeSnippet(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeSnippetMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    addContentTypeSnippet(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeSnippetMapper.mapAddContentTypeSnippetResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    listContentTypeSnippets(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeSnippetMapper.mapListingResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    projectInformation(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.projectMapper.mapProjectInformationResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    validateProjectContent(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.projectMapper.mapValidateProjectContentResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    addContentType(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeMapper.mapAddContentTypeResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    deleteContentType(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    modifyContentType(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeMapper.mapModifyContentTypeResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    modifyTaxonomy(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.taxonomyMappper.mapModifyTaxonomyResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    modifyContentTypeSnippet(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeSnippetMapper.mapModifyContentTypeSnippetResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    viewContentType(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeMapper.mapViewContentTypeResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listContentTypes(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentTypeMapper.mapListingResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listAssetRenditions(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetRenditionMapper.mapListAssetRenditionsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    viewAssetRendition(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetRenditionMapper.mapViewAssetRenditionResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    addAssetRendition(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetRenditionMapper.mapAddAssetRenditionResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    modifyAssetRendition(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetRenditionMapper.mapModifyAssetRenditionResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    addTaxonomy(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.taxonomyMappper.mapAddTaxonomyResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    deleteTaxonomy(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.taxonomyMappper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    getTaxonomy(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.taxonomyMappper.mapGetTaxonomyResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listTaxonomies(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.taxonomyMappper.mapListingTaxonomysResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    deleteAsset(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetsMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    upsertAsset(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetsMapper.mapUpsertAssetResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    addAsset(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetsMapper.mapAddAssetResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    listSubscriptionProjects(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.subscriptionMapper.mapSubscriptionProjectsListResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    litSubscriptionUsers(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.subscriptionMapper.mapSubscriptionUsersListResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    viewSubscriptionProject(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.subscriptionMapper.mapViewSubscriptionProjectResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    viewSubscriptionUser(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.subscriptionMapper.mapViewSubscriptionUserResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    activateUserInAllProjects(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapEmptyResponse(yield this.putResponseAsync(url, {}, {}, config));
        });
    }
    deactivateUserInAllProjects(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapEmptyResponse(yield this.putResponseAsync(url, {}, {}, config));
        });
    }
    uploadAssetFromUrl(uploadBinaryFileUrl, addAssetUrl, data, config) {
        const _super = Object.create(null, {
            getBinaryDataFromUrlAsync: { get: () => super.getBinaryDataFromUrlAsync },
            getMimeTypeFromFilename: { get: () => super.getMimeTypeFromFilename }
        });
        return __awaiter(this, void 0, void 0, function* () {
            // get binary data from url
            const binaryData = yield _super.getBinaryDataFromUrlAsync.call(this, data.fileUrl);
            const mimeType = _super.getMimeTypeFromFilename.call(this, data.binaryFile.filename);
            if (!mimeType) {
                throw Error(`Could not get MIME type for filename '${data.binaryFile.filename}'. Please include extension in your filename (e.g. myfile.png)`);
            }
            // upload binary file
            const uploadedBinaryFileResponse = yield this.uploadBinaryFile(uploadBinaryFileUrl, {
                binaryData: binaryData,
                contentType: mimeType,
                filename: data.binaryFile.filename,
                contentLength: binaryData.byteLength
            }, config);
            // creta asset & assign it to binary file
            const assetResponse = yield this.addAsset(addAssetUrl, {
                file_reference: {
                    id: uploadedBinaryFileResponse.data.id,
                    type: uploadedBinaryFileResponse.data.type
                },
                descriptions: data.asset.descriptions,
                external_id: data.asset.external_id,
                folder: data.asset.folder,
                title: data.asset.title
            }, config);
            return assetResponse;
        });
    }
    uploadBinaryFile(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            config.headers.push({
                header: 'Content-type',
                value: data.contentType
            });
            if (data.contentLength) {
                config.headers.push({ header: 'Content-length', value: data.contentLength.toString() });
            }
            return mappers_1.assetsMapper.mapUploadBinaryFileResponse(yield this.postResponseAsync(url, data.binaryData, {}, config));
        });
    }
    viewAsset(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetsMapper.mapViewAssetResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listAssets(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetsMapper.mapListingAssetsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listContentItems(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapListingItemsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    viewContentItem(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapViewContentItemResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    addContentItem(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapAddContentItemResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    upsertContentItem(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapUpsertContentItemResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    updateContentItem(url, data, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapUpdateContentItemResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    deleteContentItem(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    deleteLanguageVariant(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.contentItemsMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    upsertLanguageVariant(url, elements, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageVariantMapper.mapUpsertLanguageVariantResponse(yield this.putResponseAsync(url, {
                elements: elements
            }, {}, config));
        });
    }
    viewLanguageVariant(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageVariantMapper.mapViewLanguageVariantResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listLanguageVariantsOfItem(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageVariantMapper.mapLanguageVariantsOfItemResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listLanguageVariantsOfContentTypeWithComponents(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageVariantMapper.mapLanguageVariantsOfContentTypeWithComponentsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listLanguageVariantsOfContentType(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageVariantMapper.mapLanguageVariantsOfContentTypeResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listLanguageVariantsByCollection(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageVariantMapper.mapLanguageVariantsByCollectionResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listLanguages(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageMapper.mapListLanguagesResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    viewLanguage(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageMapper.mapViewLanguageResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    addLanguage(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageMapper.mapAddLanguageResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    modifyLanguage(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.languageMapper.mapModifyLanguageResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    listWebhooks(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapWebhooksListResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    getWebhook(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapGetWebhookResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    addWebhook(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapAddWebhookResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    enableWebhook(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapEnableWebhookResponse(yield this.putResponseAsync(url, {}, {}, config));
        });
    }
    disableWebhook(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapDisableWebhookResponse(yield this.putResponseAsync(url, {}, {}, config));
        });
    }
    deleteWebhook(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return webhook_mapper_1.webhookMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    listAssetFolders(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetFolderMapper.mapListAssetFoldersResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    addAssetFolders(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetFolderMapper.mapAddAssetFoldersResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    modifyAssetFolders(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.assetFolderMapper.mapModifyAssetFoldersResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    listCollections(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.collectionsMappers.mapListCollectionsResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    listRoles(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.roleMapper.mapRoleListResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    viewRole(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.roleMapper.mapViewRoleResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    setCollections(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.collectionsMappers.mapSetCollectionsResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    inviteProjectUser(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.projectUserMapper.mapInviteUserResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    changeUserRoles(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return mappers_1.projectUserMapper.mapChangeUserRolesResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    getEnvironmentCloningState(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return environment_mapper_1.environmentMapper.mapGetEnvironmentCloningStateResponse(yield this.getResponseAsync(url, {}, config));
        });
    }
    deleteEnvironment(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return environment_mapper_1.environmentMapper.mapEmptyResponse(yield this.deleteResponseAsync(url, {}, config));
        });
    }
    modifyEnvironment(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return environment_mapper_1.environmentMapper.mapModifyEnvironmentResponse(yield this.patchResponseAsync(url, data, {}, config));
        });
    }
    cloneEnvironment(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return environment_mapper_1.environmentMapper.mapCloneEnvironmentResponse(yield this.postResponseAsync(url, data, {}, config));
        });
    }
    markEnvironmentAsProduction(url, config, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return environment_mapper_1.environmentMapper.mapEmptyResponse(yield this.putResponseAsync(url, data, {}, config));
        });
    }
    getListAllResponseInternalAsync(data) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield data.getResponse(data.xContinuationToken);
            if ((_a = data.listQueryConfig) === null || _a === void 0 ? void 0 : _a.delayBetweenRequests) {
                yield this.sleep(data.listQueryConfig.delayBetweenRequests);
            }
            data.resolvedResponses.push(response);
            if ((_b = data.listQueryConfig) === null || _b === void 0 ? void 0 : _b.responseFetched) {
                data.listQueryConfig.responseFetched(response, data.xContinuationToken);
            }
            if (response.data.pagination.continuationToken) {
                // recursively fetch next page data
                return yield this.getListAllResponseInternalAsync({
                    xContinuationToken: response.data.pagination.continuationToken,
                    getResponse: data.getResponse,
                    resolvedResponses: data.resolvedResponses
                });
            }
            return data.resolvedResponses;
        });
    }
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
exports.ContentManagementQueryService = ContentManagementQueryService;
//# sourceMappingURL=content-management-query-service.class.js.map